import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SyncOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout } from 'antd';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';
import { Division } from '../../../models/index';

const { Content } = Layout;

export function DivisionsPage() {
  const { user } = useContext(UserContext);
  const [divisions, setDivisions] = useState<Division[]>();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'productionSites.sync_sap'));
  }, [user]);

  const loadDivisions = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`production-sites/divisions`)
      .then((response: any) => {
        const responseDivisions: Division[] = response.data;
        const responseData = responseDivisions.map(division => {
          return {
            key: division.id,
            ...division,
          };
        });
        setDivisions(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadDivisions();
  }, [loadDivisions]);

  const onRefreshClick = () => {
    loadDivisions();
  };

  const onSyncClick = () => {};

  const tableColumns: any[] = [
    {
      title: 'Bölüm no',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <PageHeader
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <>
            {canEdit && (
              <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
                SAP ile eşle
              </Button>
            )}
          </>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={divisions} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
